/**
 * Platform Hook - Web Version
 * Stub for desktop platform detection
 */

export function usePlatform() {
  return {
    needsFlatDesign: false, // Web always uses modern design
    isMac: navigator.platform.toLowerCase().includes('mac'),
    isWindows: navigator.platform.toLowerCase().includes('win'),
    isLinux: navigator.platform.toLowerCase().includes('linux'),
  };
}
